// Arabic

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `التسجيل مفتوح إلى غاية ${date}` : ''),
    },
    interview: {
      title: 'أجب عن أسئلة المقابلة عبر الفيديو',
      submit: 'اضغط على زر إرسال الإجابات لإكمال المقابلة. ',
      continueLater: 'استمر لاحقا',
      startInterview: 'ابدأ المقابلة',
      duplicateError: 'لقد شاركت مسبقا في هذه المقابلة. لقد تلقيت بريدًا إلكترونيًا من Invitations@recright.com والذي يضم رابط يمكن استخدامه لمواصلة المقابلة.',
      confirmSubmitHeader: 'لم تجب على جميع أسئلة المقابلة',
      confirmSubmitContent: 'هل تريد بالفعل إنهاء المقابلة؟',
      confirmSubmitContentWarning: 'وبعد ذلك، لن يمكنك إستكمال إجاباتك.',
      submitInterviewHeader: 'أرسل إجاباتك الخاصة بالمقابلة. ',
      submitInterviewContent: 'هل أنت متأكد بأنك تريد إرسال إجاباتك الخاصة بالمقابلة لإكمال المقابلة؟',
      confirmSubmitButton: 'اضغط على زر إرسال الإجابات لإكمال المقابلة. ',
      preview: 'يمكنك مراجعة أسئلة الفيديو هنا.',
      requiredQuestionsNotAnswered: 'يرجى الإجابة على جميع الأسئلة الإلزامية قبل الإرسال.',

      withdrawLink: 'هل لم تعد مهتما بهذه الوظيفة بعد الآن؟ يمكنك الإنسحاب من هذه العملية من هنا.',
    },

    personalInterview: {
      title: 'إختر الوقت المناسب للمقابلة. ',
      description: [
        'لقد تمت دعوتك إلى المقابلة. ',
        'يرجى اختيار الوقت الذي يناسبك بشكل افضل . ',
      ],
      position: 'الوظيفة:',
      location: 'الموقع:',
      time: 'التوقيت:',
      timezoneNotice: [
        'يرجى الأخذ بعين الإعتبار أن الأوقات تظهر وفقا  لمنطقتك الزمنية.',
        'التوقيت الزمني وفقا لمنطقتك هو:',
        'موعد المقابلة وفقا لمنطقتك هو:',
      ],
      success: {
        title: 'كل شيء جاهز!',
        description: 'رائع! لقد قمت ببرمجة توقيت للمقابلة!! إليك معلومات بخصوص المقابلة',
        linkDescription: [
          'يمكنك إضافة اللقاء إلى جدولك أدناه.',
          'أو يمكنك نسخ الرابط إلى التطبيق الخاص بجدولك الزمني:',
        ],
        link: 'أضف إلى جدولك الزمني',
      },
    },

    interviewForm: {
      name: 'الإسم',
      city: 'مسقط الرأس',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      link: 'رابط',
      legendBasicInfo: 'معلومات اساسية',
      placeholderName: 'سجل إسمك',
      placeholderEmail: 'سجل بريدك الإلكتروني',
      placeholderPhone: 'أدخل رقم هاتفك',
      placeholderCity: 'أدخل مسقط رأسك الحالي',
      placeholderLink: 'أضف روابط، على سبيل المثال ملفك الشخصي على LinkedIn',
      legendAttachments: 'مرفقات',
      legendAdditionalFields: 'معلومات إضافية',
      required: 'تعتبر العناصر التي تحمل علامة النجمة * إلزامية الإجابة.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'مقطع صوتي',
        video: 'فيديو',
        yes: 'نعم',
        no: 'لا',
        supported: 'مدعوم',
        quality: 'الجودة',
        header: 'الإتصال بالشبكة وتجربة إعداد المعدات',
        description: 'سنقوم الآن بإجراء تجربة للمعدات للتحقق من أن اتصال الشبكة والأجهزة اللازمة للمقابلة (الكاميرا والميكروفون) تعمل بشكل جيد. عند طلب ذلك، يرجى السماح لتطبيق الإختبار باستخدام الكاميرا والميكروفون والتحقق من عدم تغطية الكاميرا. سيستغرق وقت الاختبار حوالي 30 ثانية.ونوصي بالتحدث أثناء تجربة إعداد الأجهزة.',
        inProgress: 'الاختبار قيد الإعداد ...',
        networkTestResults: 'نتائج اختبار الاتصال بالانترنت.',
        qualityTestResults: 'نتائج اختبار جودة الاتصال',
        testPassedNetwork: 'نجح اختبار الاتصال بالشبكة',
        testFailedNetwork: 'فشل اختبار الاتصال بالشبكة',
        testPassedQuality: 'نجاح تقييم الجودة',
        testFailedQuality: 'فشل تقييم الجودة',
        startTest: 'ابدأ الاختبار',
        startInterview: 'ابدأ المقابلة',
        testAgain: 'اختبر مجددا',
        confirmTitle: 'أنت على وشك بدء المقابلة',
        confirmWarning: 'عندما تبدأ مقابلة الفيديو الخاصة بك، سيتم نقلك تلقائيًا إلى رؤية سؤال المقابلة الأول.  بعد رؤية السؤال سيتم نقلك إلى مرحلة الإعداد.',
        confirmText: 'ستحصل على وقت قصير للتحضير لإجابتك قبل كل سؤال. بعد التحضير سيكون لديك وقت محدد مسبقا للإجابة على السؤال. يرجى ملاحظة أنه يمكنك إرسال إجابتك بمجرد أن تصبح جاهزًا، حتى قبل انتهاء وقت الرد المحدد مسبقًا.',
        confirmText2: 'بعد إرسال إجابتك، سيتم نقلك إلى السؤال التالي إلى حين لا يكون هناك المزيد من الأسئلة.',
        confirmText3: 'يرجى ملاحظة أنه بعد تسجيل إجابتك على أحد الأسئلة، سيكون لديك نافذة مدتها 30 ثانية لإعادة محاولة تسجيل إجابتك إذا كان مسموحًا بإعادة الإجابة على السؤال. إذا لم تقم بإعادة تسجيل الإجابة خلال فترة ال 30 ثانية، سيتم إرسال إجابتك الموجودة تلقائيًا، وسينتقل النظام بك إلى السؤال التالي.',
        goodLuck: 'خذ نفسًا عميقًا وستكون على ما يرام. حظ سعيد!',
        qualityRating: {
          excellent: 'ممتاز',
          good: 'جيد',
          fair: 'مقبول',
          poor: 'ضعيف',
          bad: 'ضعيف جدا',
        },
      },
      questionAnswerView: {
        title: title => `أجب على أسئلة المقابلة ${title}`,
        question: 'سؤال',
        submitAndNext: 'إرسال ومتابعة ',
        submitAndFinish: 'إرسال وإنهاء المقابلة',
        submitSuccess: 'تم إرسال الفيديو بنجاح!',
        skipText: 'قم بتسجيل الاجابة',
        stop: 'توقف',
        retake: 'أعد تسجيل الإجابة',
        take: 'سجل الإجابة',
        takesLeft: 'محاولات التسجيل المتبقية',
        skipTextQuestion: 'مستعد؟ تابع',
        retakeConfirmTitle: 'هل أنت متأكد أنك تريد إعادة تسجيل الإجابة لهذا السؤال؟',
        retakeConfirmSubmit: 'نعم، ابدأ في عملية إعادة تسجيل الإجابة',
        submitInfoForward: 'سيتم إرسال إجابتك الموجودة تلقائيًا والمضي قدمًا',
        submitInfoForward2: 'خلال ثوان',
        nonAnswerableText: 'هذه الرسالة لا تتطلب ردا. بعد هذه الرسالة، سيتم نقلك مباشرة إلى السؤال التالي.',
        nonAnswerableVideo: 'هذا الفيديو لا يتطلب ردا. بعد هذا الفيديو، سيتم نقلك مباشرة إلى السؤال التالي.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `الوقت المتبقي للإجابة على السؤال: ${answerMinutes}:${answerSeconds}`,
      },
      publisher: {
        toNextQuestion: timer => `الانتقال إلى السؤال التالي بعد ${timer}`,
        recordingStarts: timer => `يبدأ التسجيل بعد ${timer}`,
      },
      errors: {
        tooManyConnections: 'تم إغلاق هذا الاتصال لأن هناك اتصالا مفتوحا مسبقا في علامة تبويب أو نافذة أخرى.',
        unsupportedBrowser: 'لسوء الحظ، هذه العملية غير مدعومة في متصفحك. الرجاء استخدام متصفح آخر.',
        networkError: 'لا يوجد اتصال بالإنترنت.',
        reconnecting: 'تمت مقاطعة الإتصال .  جارٍ محاولة إعادة الاتصال.',
        generalError: 'حدث خطأ ما. المرجو تحديث الصفحة والمحاولة مرة أخرى ',
        allowMediaDevicesError: 'فشلت هذه العملية في الوصول إلى الأجهزة السمعية البصرية (الكاميرا أو الميكروفون). يرجى التحقق من أنك سمحت للمتصفح باستخدام الكاميرا والميكروفون.',
        noAvailableDevicesError: 'لم نستطع العثور على كاميرا أو ميكروفون. يرجى التحقق من أنك سمحت للمتصفح باستخدام الكاميرا والميكروفون الخاصيين بك، وأنهما لا يستخدمهما تطبيق آخر، ثم حاول مرة أخرى . ',
        initPublisherError: 'فشلت العملية بسبب مشكلة ما. يرجى التحقق من أنك سمحت للمتصفح باستخدام الكاميرا والميكروفون الخاصيين بك، وأنهما لا يستخدمهما تطبيق آخر، ثم حاول مرة أخرى. ',
      },
      browserInfo: {
        browserSupportTitle: 'دعم المتصفح',
        supportedBrowsers: 'يدعم هذا الاختبار والمقابلة أحدث إصدارات Chrome وFirefox وSafari وEdge.',
        mobileSupported: 'المتصفحات المدعومة للهاتف. ',
        android: 'نظام الأندرويد Android  Google Chrome(أحدث إصدار)، Firefox (أحدث إصدار)',
        iOS: 'نظام iOS: Safari (أحدث إصدار)',
        latestVersion: 'يرجى التأكد من أنك تستخدم أحدث إصدار من المتصفح. وهذا  لضمان تشغيل كل شيء بسلاسة.',
        freezeInstruction: 'إذا لم يبدأ تسجيل الفيديو، أو ظلت شاشة التسجيل سوداء، يرجى تحديث الصفحة.',
        unsupportedOnIos: 'يبدو أنك تستخدم متصفحًا غير مدعوم على نظام تشغيل iOS. الرجاء استخدام متصفح Safari.',
        ieUnsupported: 'يبدو أنك تستخدم Internet Explorer للأسف، هذا المتصفح غير مدعوم لهذا الاختبار أو المقابلة. يرجى استخدام متصفح آخر.',
        qualityTestNotSupported: 'للأسف، اختبار الأجهزة غير مدعوم في المتصفح الذي تستخدمه. يمكنك الاستمرار في المقابلة بدون تجربة جودة الصوت والفيديو، أو بدلاً من ذلك، يمكنك استخدام متصفح آخر. ',
      },
      reconnectSuccess: 'تمت إعادة الاتصال بنجاح!',
      continue: 'استمر',
    },

    withdraw: {
      title: 'هل لم تعد مهتما بهذه الوظيفة بعد الآن؟',
      description: 'أزل نفسك من عملية التوظيف.',
      buttonText: 'تراجع عن عملية التوظيف.',
      thankYouTitle: 'شكرًا لك.',
      thankYouText: 'لقد قمت الآن بإزالة نفسك من عملية التوظيف.',
      confirm: 'هل أنت متأكد بأنك تريد التراجع عن عملية التوظيف؟ بعد الانسحاب، لن يكون بإمكانك الإجابة بعد الآن، أو أي مقابلة أخرى تتعلق بهذه الوظيفة. ',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'أرسل',
      continue: 'استمر',
      supportCenter: 'مركز مساعدة ReCright.',
      thankYou:
        'شكرا لك على تقديم الإجابة عبر الفيديو.  سنتواصل معك قريبا!',
    },

    supportLink: 'support@recright.com',

    finished: {
      reopenDescription: 'إذا قمت بإغلاق هذه المقابلة عن طريق الخطأ، فلا عليك! يمكنك إعادة فتح المقابلة بالنقر على الزر أدناه!',
      reopenButtonText: 'إعادة فتح المقابلة',
      title: 'شكرا لك على اتمام المقابلة!',
      description1: 'مذهل! لقد أجبت الآن على جميع أسئلة المقابلة، وسترسل إجاباتك إلى مسؤول التوظيف. ابق على إطلاع!',
      descriptionsupport: mailto => `إذا قمت بإغلاق هذه المقابلة عن طريق الخطأ، فلا عليك! كل ما عليك فعله فقط هو الاتصال بدعم العملاء وسنعيد فتح المقابلة لك. ${mailto}`,
      descriptionfeedback: 'تجربتك تهمنا جدا! نود أن نعرف ما هو شعورك تجاه الإجابة على مقابلة الفيديو. كيف يمكننا تحسين خدماتنا؟ بإمكانك مشاركة ملاحظاتك هنا:',
      feedbackbutton: 'شارك ملاحظاتك:',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'ملاحظة شخصية',
    },

    closed: {
      title: 'لقد اكتملت المقابلة بنجاح أو انتهت المقابلة.',
      description: 'لقد انتهت مسبقا مقابلة الفيديو التي تمت دعوتك إليها أو أكملت إرسال إجاباتك. ',
      publicTitle: 'انتهت المقابلة',
      publicDescription: 'انتهت مسبقا مقابلة الفيديو التي كنت تبحث عنها.',
    },
    saved: {
      title: 'لقد تم حفظ مقابلة الفيديو الخاصة بك بنجاح. ',
      description: 'عند رغبتك في متابعة المقابلة عبر الفيديو، استخدم الرابط الذي تلقيته مسبقًا عبر بريدك الإلكتروني. ستبقى الإجابات المسجلة عبر الفيديو متاحة عند عودتك! نتمنى لك التوفيق في بحثك عن عمل!',
      remember: 'تأكد من إرسال الإجابات إلى مسؤول التوظيف بعد الانتهاء من الإجابة على أسئلة المقابلة.',
      deleteHistory: 'إذا كنت تستخدم جهاز كمبيوتر عام لإجراء المقابلة عبر الفيديو، يرجى التأكد من مسح سجل التصفح الخاص بك. وبهذه الطريقة تكون قد أجريت مقابلتك بشكل آمن . ',
    },
    unpublished: {
      title: 'لم تبدأ المقابلة بعد',
      publishTime: publishTime => `ستفتح المقابلة يوم ${publishTime}`,
    },
  },
}
